import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { preloadResources, measurePerformance } from './lib/performance';

// Iniciar medición de performance
const endMeasure = measurePerformance('app_load');

// Precargar recursos críticos
preloadResources();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// Finalizar medición cuando la app esté cargada
window.addEventListener('load', endMeasure);